<div class="d-flex flex-column">
  <form (ngSubmit)="onMasterSearch(true)">
    <span class="search-text">Search by name</span>
    <input
      class="dp-input-control update-input mt-2"
      placeholder="Search By Name"
      [formControl]="name"
    />
    <div class="d-flex align-items-center btn-margin">
      <button class="dp-secondary-btn clear-btn" type="reset" (click)="onClickClear()">
        Clear Entries
      </button>
      <button class="dp-primary-btn search-btn ms-3">Search</button>
    </div>
  </form>

  @if(isLoader){
  <table class="dp-table table-container">
    <thead class="dp-table-header">
      <tr>
        <th>Sl.no</th>
        <th>Mem Status</th>
        <th>District</th>
        <th>Name</th>
        <th>Guardian</th>
        <th>Initiation Date</th>
        <th>Ritwik</th>
        <th>Pin</th>
        <th>Adress</th>
      </tr>
    </thead>
    <tbody class="dp-table-body">
      <tr *ngFor="let i of [].constructor(numberOfLoaders)">
        <td *ngFor="let j of [].constructor(9)">
          <dp-loader></dp-loader>
        </td>
      </tr>
    </tbody>
  </table>
  } 
  @else if(responseData.length>0) {
  <div
    class="dp-table-scroll table-container"
    infiniteScroll
    [scrollWindow]="false"
    [infiniteScrollDistance]="1"
    [infiniteScrollThrottle]="1000"
    (scrolled)="onScroll()"
    #tableContainer
  >
    <dp-table
      [dataTable]="responseData"
      [displayedColumns]="displayColumnData"
      [componentMap]="cellComponentMap"
      [columnConfs]="columnConfs"
      (cellClick)="onCellClick($event)"
    ></dp-table>
  </div>
  } 
  @else {
  <div class="noData" *ngIf="noDataFound">
    <div class="placeholderTable"></div>
    <p>No data found!</p>
  </div>
  }
</div>
